import * as React from 'react';
import CarePartnerForm from '../components/CarePartnerForm';

function AddClinic() {
    return (
        <>
            <h1 style={{ marginBlock: "20px", textAlign: "center" }}>Clinic Onboarding</h1>
            
            <div style={{ 
                textAlign: "center", 
                marginTop: "10px", 
                marginBottom: "10px",
            }}>
                <p style={{ 
                    fontSize: "14px", 
                    color: "#495057", 
                    margin: "0",
                    lineHeight: "1.5"
                }}>
                    <a 
                        href="https://docs.google.com/document/d/1rhV9Peb94qnaB96N1e0UnF71Q6aj5Oyc1_D445PCr7c/edit?tab=t.0" 
                        target="_blank" 
                        rel="noreferrer"
                        style={{ 
                            color: "#1976d3", 
                            textDecoration: "none",
                            fontWeight: "500"
                        }}
                        onMouseEnter={(e) => e.target.style.textDecoration = "underline"}
                        onMouseLeave={(e) => e.target.style.textDecoration = "none"}
                    >
                        Click here to review instructions on how to onboard a clinic
                    </a>
                </p>
            </div>
            <CarePartnerForm />
        </>
    );
}
export default AddClinic;